import React from "react";
import { DineInSessionMember } from "../../../../interfaces/DineInObject";
import "./styles/DineInTableRoster.css";

interface DineInTableRosterProps {
  members: DineInSessionMember[];
  hostId: string;
}

/**
 * Renders only when members[] is non-empty — the confirmed dine-in-session
 * response doesn't include a members array at all yet, so this stays hidden
 * until the backend adds it (see the RawDineInSession note in DineInObject.ts).
 */
const DineInTableRoster: React.FC<DineInTableRosterProps> = ({ members, hostId }) => {
  if (members.length === 0) return null;

  return (
    <div className="dine-in-table-roster">
      <div className="dine-in-table-roster__header">
        <span>At the table</span>
        <span>{members.length}</span>
      </div>
      {members.map((m) => (
        <div key={m.memberId} className="dine-in-table-roster__row">
          <span className="dine-in-table-roster__avatar">
            {m.memberName.slice(0, 2).toUpperCase()}
          </span>
          <span className="dine-in-table-roster__name">{m.memberName}</span>
          <span className="dine-in-table-roster__role">
            {m.memberId === hostId ? "host" : "joined"}
          </span>
        </div>
      ))}
    </div>
  );
};

export default DineInTableRoster;
